var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-twitter",
    transform: "translate(-0.099 -0.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-twitter",
    "data-name": "Icon simple-twitter",
    d: "M34.185,6.684A14.272,14.272,0,0,1,30.153,7.79,7.076,7.076,0,0,0,33.24,3.9a14.5,14.5,0,0,1-4.463,1.69,7.019,7.019,0,0,0-12.146,4.792,7.185,7.185,0,0,0,.181,1.6A19.886,19.886,0,0,1,2.34,4.675a6.881,6.881,0,0,0-.95,3.532,7.022,7.022,0,0,0,3.122,5.845,7,7,0,0,1-3.18-.879v.087a7.026,7.026,0,0,0,5.631,6.889,7.086,7.086,0,0,1-3.157.121,7.045,7.045,0,0,0,6.57,4.876,14.083,14.083,0,0,1-8.708,3,14.9,14.9,0,0,1-1.67-.1,19.973,19.973,0,0,0,10.785,3.152c12.921,0,19.978-10.7,19.978-19.959,0-.3,0-.6-.021-.9a14.179,14.179,0,0,0,3.511-3.636l-.067-.029Z",
    transform: "translate(26.215 25.03)",
    fill: "#0d9648"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    transform: "translate(0.099 0.099)",
    fill: "none",
    stroke: "#0d9648",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTwitter);
export default __webpack_public_path__ + "static/media/ico-twitter.88b9db76e6100f6806920c0c5ae1bbab.svg";
export { ForwardRef as ReactComponent };